// extracted by mini-css-extract-plugin
export var banner = "banner-module--banner--7q6lT";
export var btn = "banner-module--btn--0-8Aa";
export var container = "banner-module--container--IYdpk";
export var descAB = "banner-module--descAB--o6hDd";
export var headAB = "banner-module--headAB--Zi4a4";
export var img = "banner-module--img--UQRmR";
export var section = "banner-module--section--DYAl5";
export var text = "banner-module--text--28eD6";